import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IArea } from '@app/models/area.interface';
import { skipWhile } from 'rxjs';
import { SubSink } from 'subsink';
import { Store } from '@ngrx/store';
import { selectAreasState } from '@app/modules/organization/store/selectors/organization.selectors';
import * as OrganizationActions from '@app/modules/organization/store/actions/organization.actions';
import { FormComponent } from '@app/modules/organization/areas-table/form/form.component';
import { BreakpointService } from '@app/services/breakpoint/breakpoint.service';

@Component({
  selector: 'app-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  styleUrls: ['./checkbox-list.component.scss']
})
export class CheckboxListComponent implements OnInit {
  private subs: SubSink = new SubSink;
  public areas$: IArea[];
  constructor(
    private dialogRef: MatDialogRef<CheckboxListComponent>,
    private store$: Store,
    private _breakpoints:BreakpointService,
    private _matDialog: MatDialog
  ) {

  }

  ngOnInit(): void {
    this.subs.add(this.store$.select(selectAreasState).pipe(
      skipWhile(areas => areas == null)
      ).subscribe((areas: IArea[]) => {
      this.areas$ = areas
    }));
  }

  ngOnDestroy():void{
    this.subs.unsubscribe();
  }

  onSetCheckbox(event: any) {
    this.store$.dispatch(OrganizationActions.checkArea({ 
      prdAreaID: event.option._value,
      checked: event.option._selected
     }));
  }

  cancel(){
    this.dialogRef.close();
  }

  onOpenAreas(){
    this._matDialog.open(FormComponent, {
      data: {
        type: 'Add',
        area: null
      },
      width: this._breakpoints.isMobile() === true ? "70vw" : "25vw",
    });
  }

}
